// @ts-nocheck

//Get file mime type from buffer
export const getMimeTypeFromBuffer = (buffer) => {
  const uint = new Uint8Array(buffer);
  const hex = Array.from(uint.slice(0, 16))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join(' ')
    .toUpperCase();

  // First 4-16 bytes matching
  if (hex.startsWith('89 50 4E 47')) return 'image/png';
  if (
    hex.startsWith('FF D8 FF E0') ||
    hex.startsWith('FF D8 FF E1') ||
    hex.startsWith('FF D8 FF DB')
  )
    return 'image/jpeg';
  if (hex.startsWith('47 49 46 38')) return 'image/gif';
  if (hex.startsWith('25 50 44 46')) return 'application/pdf';
  if (hex.startsWith('50 4B 03 04')) return 'application/zip'; // DOCX, XLSX, PPTX, etc.
  if (hex.startsWith('D0 CF 11 E0 A1 B1 1A E1'))
    return 'application/vnd.ms-office'; // old DOC, XLS, PPT
  if (hex.startsWith('52 49 46 46') && hex.includes('57 45 42 50'))
    return 'image/webp';
  if (hex.startsWith('42 4D')) return 'image/bmp';
  if (hex.startsWith('49 49 2A 00') || hex.startsWith('4D 4D 00 2A'))
    return 'image/tiff';
  if (hex.startsWith('00 00 01 00')) return 'image/x-icon'; // ICO
  if (hex.startsWith('00 00 00 18 66 74 79 70')) return 'video/mp4'; // MP4
  if (hex.startsWith('4F 67 67 53')) return 'audio/ogg';
  if (hex.startsWith('66 4C 61 43')) return 'audio/flac';
  if (hex.startsWith('49 44 33')) return 'audio/mpeg'; // MP3 with ID3
  if (hex.startsWith('FF FB')) return 'audio/mpeg'; // MP3 without ID3
  if (hex.startsWith('52 49 46 46') && hex.includes('57 41 56 45'))
    return 'audio/wav';
  if (hex.startsWith('00 61 73 6D')) return 'application/wasm';
  if (hex.startsWith('3C 3F 78 6D 6C')) return 'application/xml';

  return 'application/octet-stream'; // Fallback for text, unknowns
};
